import { render, staticRenderFns } from "./matchMapping.vue?vue&type=template&id=13e10746&scoped=true"
import script from "./matchMapping.vue?vue&type=script&lang=js"
export * from "./matchMapping.vue?vue&type=script&lang=js"
import style1 from "./matchMapping.vue?vue&type=style&index=1&id=13e10746&prod&lang=scss&scoped=true"
import style2 from "./matchMapping.vue?vue&type=style&index=2&id=13e10746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e10746",
  null
  
)

export default component.exports